import { Component, Input } from '@angular/core';


@Component({
  selector: 'app-delivery-items-table-shipping-name',
  standalone: true,
  imports: [],
  templateUrl: './delivery-items-table-shipping-name.component.html',
  styleUrl: './delivery-items-table-shipping-name.component.scss'
})
export class DeliveryItemsTableShippingNameComponent {
  @Input() deliveryInWeeksFrom: number = 2;
  @Input() deliveryInWeeksTo: number = 4;
}
